import axios from 'axios';


export const CONTACTAPI = axios.create({
    baseURL: 'https://contact.ova-consulting.fr/contact/v1/',
    // timeout: 10000,
});
